import {useTranslation} from 'react-i18next'
import '../services/getI18n'

export function useI18n(namespace, options) {
  return useTranslation(namespace, options)
}
